import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";

const RefundPolicy = () => {
  return (
    <>
      <Meta title={"Refund Policy"} />
      <BreadCrumb title="Refund Policy" />
      <Container class1="policy-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <div className="policy">
              <h2>Refund Policy</h2>
              <p>
                At <strong>Softech</strong>, we strive to provide you with the best possible service. 
                If you are not satisfied with your purchase, we’re here to help.
              </p>

              <h3>1. Eligibility for Refund</h3>
              <ul>
                <li>Refund requests must be made within <strong>7 days</strong> of the purchase date.</li>
                <li>The product must be unused and in the same condition that you received it.</li>
                <li>Your item must be in the original packaging.</li>
                <li>You must provide a valid receipt or proof of purchase.</li>
              </ul>

              <h3>2. No Return Policy</h3>
              <p>
                We do not accept returns of products once they have been delivered unless they are 
                defective or damaged upon arrival. If you receive a defective or damaged item, 
                please contact us immediately with proof of damage, and we will assess the case accordingly.
              </p>

              <h3>3. Refund Process</h3>
              <p>
                Once we receive your return, we will inspect the product and notify you on the 
                status of your refund. If approved, the refund will be credited within 
                <strong>7–10 business days</strong> to your original payment method.
              </p>

              <h3>4. Late or Missing Refunds</h3>
              <p>
                If you haven’t received a refund within 10 business days, first check your bank account. 
                Then contact your credit card company—it may take some time before your refund is officially posted.
              </p>

              <h3>5. Contact Us</h3>
              <p>
                If you have any questions about our Refund Policy, please contact us at:  
                <a href="mailto:softechmathikere@gmail.com">softechmathikere@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default RefundPolicy;
